"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _chart_utility = require("../../../../packages/common-utilities/src/chart_utility");

var _string_utility = require("../../../../packages/common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PremiumDiscountChart = function (_React$Component) {
  _inherits(PremiumDiscountChart, _React$Component);

  function PremiumDiscountChart() {
    _classCallCheck(this, PremiumDiscountChart);

    return _possibleConstructorReturn(this, (PremiumDiscountChart.__proto__ || Object.getPrototypeOf(PremiumDiscountChart)).apply(this, arguments));
  }

  _createClass(PremiumDiscountChart, [{
    key: "createPremiumDiscountChart",
    value: function createPremiumDiscountChart(printWidth) {
      var data = this.props.premiumDiscountRangeFiltered;
      var NUMDAYS = this.props.numDays;
      var breakpoint = this.props.breakpoint;
      var xAxisLabelVisible = breakpoint >= 4;
      var marginLeft = breakpoint < 4 ? 60 : 70;
      var marginBottom = breakpoint < 4 ? 0 : 40;
      var fontSize = breakpoint < 4 ? "12px" : "15px";

      if (breakpoint < 2) {
        fontSize = "9px";
      } else if (breakpoint < 3) {
        fontSize = "12px";
      } else if (breakpoint < 4) {
        fontSize = "14px";
      }
      var daysLabel = _string_utility2.default.getLocalizedString(this.props.intl, 'Days', 'pdp-premium-discount-chart-days-label');
      var dayLabel = _string_utility2.default.getLocalizedString(this.props.intl, 'Day', 'pdp-premium-discount-chart-day-label');
      var daysLabelUpperCase = _string_utility2.default.getLocalizedString(this.props.intl, 'DAYS', 'pdp-premium-discount-chart-days-label');
      /* eslint-disable*/
      var spec = {
        "keys": ["premiumDiscountRangeTypeCode"],
        "values": ["premiumDiscountRangeDayCount"],
        "container": {
          "marginLeft": marginLeft,
          "marginTop": 40,
          "marginBottom": marginBottom, "height": 500
        },
        "padding0": 0,
        "label": {
          "text": function text() {
            return '';
          }
        },
        "endLabel": {
          "text": function text(d, node) {
            if (d.premiumDiscountRangeDayCount === 1) {
              d3.select(node.parentNode).append("text").attr("text-anchor", "middle").attr("transform", "translate(0,-20)").attr("style", "font-weight: 400;font-size:" + fontSize).text(d.premiumDiscountRangeDayCount + " " + dayLabel);
            } else if (d.premiumDiscountRangeDayCount > 1) {
              d3.select(node.parentNode).append("text").attr("text-anchor", "middle").attr("transform", "translate(0,-20)").attr("style", "font-weight: 400;font-size:" + fontSize).text(d.premiumDiscountRangeDayCount + " " + daysLabel);
            }
            return d.premiumDiscountRangeDayCount ? Math.round(d.premiumDiscountRangeDayCount / NUMDAYS * 100) + '%' : "";
          },
          "position": "adjacent",
          "style": {
            "font-family": "NBInternational",
            "font-size": fontSize,
            "font-weight": "300"
          }
        },
        "style": {
          "fill": function fill(d) {
            var premiums = ['0%', '0 to 1%', '1 to 2%', '2 to 3%', '3 to >3%'];
            if (premiums.indexOf(d.premiumDiscountRangeTypeCode) !== -1) {
              return "#70C4FF";
            } else {
              return "#00A16D";
            }
          }
        },
        "axis": {
          "x": {
            "show": xAxisLabelVisible,
            "label": {
              "show": xAxisLabelVisible,
              "style": {
                "font-family": "NBInternational",
                "font-size": fontSize
              }
            },
            "tick": {
              "padding": 10
            }
          },
          "y": {
            "show": true,
            "label": {
              "text": function text(d) {
                if (d === 0) {
                  return "";
                } else {
                  return d + " " + daysLabelUpperCase;
                }
              },
              "style": {
                "font-family": "NBInternational",
                "font-size": fontSize
              }
            },
            "ticks": 8,
            "tick": {
              "padding": 10,
              "grid": true,
              "style": {
                "stroke": "lightgrey"
              }
            }
          }
        },
        "postProcessing": function postProcessing(chart) {
          var ticks = chart.getSVG().select(".x-axis").selectAll(".tick");
          var shiftAmount = d3.select(".firevis-bar").select("rect").attr("width");
          ticks.select('line').attr("transform", 'translate(' + shiftAmount / 2 + ')');
        }

      };

      if (printWidth && typeof printWidth === "number") {
        spec.container.width = (0, _chart_utility.getChartPrintWidth)();
        spec.container.height = (0, _chart_utility.getChartPrintHeight)();
      }

      return (0, _chart_utility.generateChart)((0, _chart_utility.generateChartId)("PremiumDiscountBarChart", printWidth && typeof printWidth === "number"), "bar", data, spec);
      /* eslint-enable*/
    }
  }, {
    key: "render",
    value: function render() {
      var chart = this.createPremiumDiscountChart();
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "print-hide" },
          _react2.default.createElement(chart)
        ),
        _react2.default.createElement(
          "div",
          { className: "print-display", style: { display: "none" } },
          _react2.default.createElement(this.createPremiumDiscountChart(800))
        )
      );
    }
  }]);

  return PremiumDiscountChart;
}(_react2.default.Component);

exports.default = PremiumDiscountChart;